import API from 'services/api';

export const getUserTypeEditRole = (roleId: number) =>
  API.get(`/api/roles/${roleId}/edit`).then(response => response?.data);
